<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <div class="page">
                <div class="tipos-servicos vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("gerenciar-usuarios") }}

                                <a
                                    v-if="hide.hideInfo"
                                    class="pl-1"
                                    @click="infoIsHidden()"
                                >
                                    <b-icon
                                        v-if="!hide.infoIsHidden"
                                        icon="eye-off-outline"
                                        type="is-danger"
                                    />
                                    <b-icon
                                        v-if="hide.infoIsHidden"
                                        icon="eye-outline"
                                        type="is-success"
                                    />
                                </a>
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("colaborador")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("gerenciar-usuarios")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        <div class="header-buttons">
                            <button
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: 'usuario-gerenciar-new',
                                    })
                                "
                                v-if="!usuarioIntegracao && permissao.create && !limiteQdaAtivos"
                            >
                                {{ $t("adicionar") }} 
                            </button>
                        </div>
                    </div>
                    <div v-if="!usuarioIntegracao && permissao.create && limiteQdaAtivos">
                        <article class="message is-danger">
                            <div class="message-body">
                                {{ $t('qtde_max_usuario_aparelho') }}
                            </div>
                        </article>
                    </div>

                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>

                        <div class="situacao-select">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="onSituacaoChanged"
                                v-model="filters.situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t("sem-resultados")
                                }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <container-loader
                            v-if="isLoading && !$store.getters.isLoading"
                        />
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="usuarios"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="
                                    f.key == 'excluir' ? '' : $t(f.key)
                                "
                                :width="f.width"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'codigo'">
                                    <span>{{ props.row[f.key] }}</span>
                                </div>
                                <div v-else-if="f.key == 'nome'">
                                    <router-link
                                        v-if="props.row.situacao == 'A'"
                                        :to="{
                                            name: 'usuario-gerenciar-edit',
                                            params: { id: props.row.idusuario},
                                        }"
                                    >
                                        <HideInfo
                                            v-if="!cleanHide"
                                            :value="props.row[f.key]"
                                            :hideInfo="hide.hideInfo"
                                            :infoIsHidden="hide.infoIsHidden"
                                        />
                                    </router-link>
                                    <span v-else>
                                        <HideInfo
                                            v-if="!cleanHide"
                                            :value="props.row[f.key]"
                                            :hideInfo="hide.hideInfo"
                                            :infoIsHidden="hide.infoIsHidden"
                                        />
                                    </span>
                                </div>

                                <div v-else-if="f.key == 'login'">
                                    <HideInfo
                                        v-if="!cleanHide"
                                        :value="props.row[f.key]"
                                        :hideInfo="hide.hideInfo"
                                        :infoIsHidden="hide.infoIsHidden"
                                    />
                                </div>

                                <div
                                    v-else-if="f.key == 'localizacao'"
                                    class="has-text-centered"
                                >
                                    <span @click="openLocationEditor(props.row)">
                                        <b-icon
                                            class="map-marker"
                                            pack="fas"
                                            icon="map-marker-alt"
                                            :type="
                                                verifyLocationIsValid(
                                                    props.row.latitude,
                                                    props.row.longitude
                                                )
                                                    ? 'is-primary'
                                                    : 'is-danger'
                                            "
                                            v-tippy 
                                            :title="verifyLocationIsValid(
                                                    props.row.latitude,
                                                    props.row.longitude
                                                )
                                                    ? $t('editar-coordenada')
                                                    : $t(
                                                        'msg-warning-customer-with-wrong-coordinates'
                                                    )"
                                        />
                                    </span>
                                </div>

                                <div
                                    v-else-if="f.key == 'excluir'"
                                    style="text-align: center"
                                >
                                    <div v-if="props.row.situacao == 'I'">
                                        <b-button
                                            v-if="permissao.update && !limiteQdaAtivos"
                                            type="is-success"
                                            @click="
                                                confirmEnable(props.row)
                                            "
                                            icon-right="check"
                                            position="is-left"
                                            v-tippy 
                                            :title="$t('ativar')"
                                        />
                                    </div>
                                    <div v-else>
                                        <b-button
                                            v-if="permissao.delete"
                                            type="is-danger"
                                            @click="
                                                confirmExclusion(props.row)
                                            "
                                            icon-right="delete"
                                            position="is-left"
                                            v-tippy 
                                            :title="$t('inativar')"
                                        />
                                    </div>
                                </div>

                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>

                    <MapasGoogleMapsModal
                        v-if="permissao.update"
                        :center="center"
                        :isUpdating="isUpdatingClient"
                        :locationEditorOpen="locationEditorOpen"
                        :update="true"
                        @updateLocation="updateLocation"
                        @onCancelLocationEditor="onCancelLocationEditor"
                    />
                </div>

                <b-modal v-model="newLoginModal" scroll="keep">
                    <div class="card" color="primary">
                        <header class="card-header">
                            <p class="card-header-title">
                                {{ loginModalTitle }}
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <v-input
                                    class="is-100"
                                    ref="newLoginInput"
                                    title="login"
                                    v-model="newLogin"
                                    :invalid="!newLogin"
                                    :maxlength="100"
                                    validchars="abcdefghijklmnopqrstuvwxyz0123456789@-._"
                                />
                            </div>

                            <div class="header-buttons">
                                <button
                                    class="save-btn"
                                    type="button"
                                    tag="button"
                                    @click="confirmEnableAfterNewLogin"
                                >
                                    {{ $t("confirmar") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader.vue";
import GerenciarUsuariosService from "@/services/conta/GerenciarUsuariosService.js";
import ParametrizacaoService from "@/services/ParametrizacaoService.js";
import MMChaveLiberacaoService from "@/services/MMChaveLiberacaoService.js";
import MapasGoogleMapsModal from "@/components/shared/maps/MapasGoogleMapsModal.vue";
import HideInfo from "@/components/shared/HideInfo.vue";
import { mapState } from "vuex";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes("usuario-gerenciar") &&
            to.name != "usuario-gerenciar-list"
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        ContainerLoader,
        MapasGoogleMapsModal,
        HideInfo,
    },
    data() {
        return {
            cleanHide: true,
            usuarios: [],
            usuarioIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("USUARIO"),
            service: new GerenciarUsuariosService(this.$http, this.$router),
            service_mm: new MMChaveLiberacaoService(this.$http, this.$router),
            parametrizacaoService: new ParametrizacaoService(
                this.$http,
                this.$router
            ),
            fields: [
                {key: "codigo", width: null, sortable: true, sortFn: null},
                { key: "nome", width: null, sortable: true, sortFn: null },
                { key: "login", width: null, sortable: true, sortFn: null },
                {
                    key: "localizacao",
                    width: 70,
                    sortable: false,
                    sortFn: null,
                },
                { key: "excluir", width: 70, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            filters: {
                situacao: { id: 1, label: "ativos" },
                column: "name",
                order: "asc",
                queryFilter: "",
            },
            permissao: {},
            center: {
                lat: null,
                lng: null,
            },
            locationEditorOpen: false,
            cancelLocationEditor: false,
            isUpdatingClient: false,
            idusuario: null,
            ipaddress: null,
            newLoginModal: false,
            loginModalTitle: "",
            newLogin: "",
            enableThis: {},
            rotaAninhada: false,
            qtdUsuariosAtivos: 0,
            limiteQdaAtivos: false,
        };
    },
    computed: {
        ...mapState(["hide"]),
    },
    created() {
        this.rotaAninhada = (
            this.$route.name.includes("usuario-gerenciar") &&
            this.$route.name != "usuario-gerenciar-list"
        );

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "admin",
            "colaborador",
            "usuario-gerenciar"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "gerenciar-usuarios" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
            this.getIpAdress();
            this.qtdMaxUsuarioVsQtdAtivos();
        }
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        verifyLocationIsValid(lat, lng) {
            let validLatitude =
                lat >= -90 && lat <= 90 && lat != 0.0 ? true : false;
            let validLongitude =
                lng >= -180 && lng <= 180 && lng != 0.0 ? true : false;
            return validLatitude && validLongitude ? true : false;
        },
        openLocationEditor(usuario) {
            this.center.lat = +usuario.latitude;
            this.center.lng = +usuario.longitude;
            this.idusuario = usuario.idusuario;
            this.locationEditorOpen = true;
        },
        onCancelLocationEditor() {
            this.locationEditorOpen = false;
            this.center.lat = 0;
            this.center.lng = 0;
            this.idusuario = null;
        },
        updateLocation(val) {
            this.isLoading = true;
            this.center.lat = val.center.lat;
            this.center.lng = val.center.lng;
            let form = {
                idusuario: this.idusuario,
                latitude: this.center.lat,
                longitude: this.center.lng,
            };
            this.service
                .updateLocation(form)
                .then((body) => {
                    this.$root.showMessage("success", "msg-dados-alterados");
                    this.carregarDados(this.pagination.currentPage);
                    this.onCancelLocationEditor();
                })
                .catch((e) => {
                    console.error("Erro ao salvar a localização do usuario.", e);
                    this.$root.showMessage(
                        "error",
                        "msg-problema-realizar-acao"
                    );
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        validateEditLocation() {
            if (this.mapa.cliente != null) {
                this.service
                    .loadClienteReduced(this.mapa.cliente.idusuario)
                    .then((value) => {
                        if (value.content) this.selectedClient = value.content;
                        this.isLoading = false;
                        if (value.content) {
                            this.mapa.cliente = value.content;
                            this.isLoading = false;
                        }
                    });
                this.isShowingLocationEditor = true;
            }
        },

        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.filters.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.filters.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.filters.column,
                    this.filters.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.filters.situacao.id,
                    this.filters.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.usuarios = value;
                    this.isEmpty = this.usuarios.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os acertos.");
                })
                .finally(() => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    idusuario: m.idusuario,
                    idusuarioerp: m.idusuarioerp,
                    codigo: m.idusuarioerp,
                    nome: m.nome,
                    login: m.login,
                    situacao: m.situacao,
                    latitude: m.latitude,
                    longitude: m.longitude,
                    excluir: "excluir-colaborador",
                };
            });
            return list;
        },
        getIpAdress() {
            fetch("https://api.ipify.org?format=json")
                .then((x) => x.json())
                .then(({ ip }) => {
                    this.ipaddress = ip;
                });
        },
        sortTable(field, order) {
            this.filters.column = field;
            this.filters.order = order;
            this.carregarDados();
        },
        confirmEnableAfterNewLogin() {
            if (this.enableThis && this.newLogin && this.newLogin != "") {
                this.isLoading = true;
                // CHECK LOGIN REPETIDO
                this.service
                    .validateLogin(this.newLogin.toLowerCase())
                    .then((r) => {
                        if (r.status == 200) {
                            this.enableThis.login = this.newLogin.toLowerCase();
                            this.ativar();
                        } else {
                            this.$root.showMessage("error", r.message);
                        }
                    })
                    .catch((e) => {
                        this.isLoading = false;
                        console.error("Erro ao inativar colaborador.", e);
                        if (e.message) {
                            this.$root.showMessage("error", e.message);
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-erro-verificar-login"
                            );
                        }
                    });
            }
        },

        confirmExclusion(item) {
            this.deleteThis = item;
            let message = this.$t("msg-confirm-inativar-colaborador", { n: item.nome });
            message = message + this.$t("atencao-desativar-usuario");

            this.$root.confirm({
                message: message,
                onConfirm: this.excluir,
                onCancel: this.removePrompt,
            });
        },
        confirmEnable(item) {
            this.enableThis = item;
            if (item.login) {
                this.$root.confirm({
                    message: this.$t("msg-confirm-reativar-colaborador", { n: item.nome }),
                    onConfirm: this.ativar,
                    onCancel: this.removePrompt,
                });
            } else {
                this.newLogin = "";
                this.$root.confirm({
                    message: this.$t("msg-confirm-ativar-colaborador", { n: item.nome }),
                    onConfirm: () => {
                        this.loginModalTitle = this.$t("informe-login-para-n", { n: item.nome });
                        this.newLoginModal = true;
                    },
                    onCancel: this.removePrompt,
                });
            }
        },
        excluir() {
            this.isLoading = true;

            // Cria o objeto que sera inserido na tabela mm_chave_liberacao
            this.deleteThis.mmChaveLiberacao = {
                cliente_sovis_id: this.$store.state.user.idClienteSovis,
                vendedor_id: null,
                aparelho_id: null,
                imei: null,
                operacao: "I",
                mm_user_id: 1,
                mm_user_name: this.$store.state.user.nome,
                codigo_chamado: null,
                observacao: null,
                faturar: "N",
                faturado: "N",
                datafaturado: null,
                ip: this.ipaddress,
                macaddress: "AAAA:BBBB:CCCC:DDDD",
                license_key: null,
                aparelho_inativado_id: "0",
                id_fvw_usuarios: this.$store.state.user.id,
            };
            this.service
                .desativar(this.deleteThis)
                .then((_) => {
                    this.$root.showMessage(
                        "success",
                        "msg-success-inativar-colaborador"
                    );
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error("Erro ao inativar colaborador.", e);
                    this.$root.showMessage(
                        "error",
                        "msg-failure-inativar-colaborador"
                    );
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.removePrompt()
                });
        },
        ativar() {
            this.newLoginModal = false;
            this.isLoading = true;
            this.service
                .ativar(this.enableThis)
                .then((body) => {
                    if (body.status != 200) {
                        if (this.$te(body.message)) {

                            this.$root.showMessage("alert", this.$t(body.message), true);
                            
                            setTimeout(() => {
                                location.reload();
                            }, 1000);
            
                        } else if (body.message) {
                            this.$root.showMessage("alert", body.message, true);
                        }
                    } else {
                        this.$root.showMessage(
                            "success",
                            "msg-success-reativar-colaborador"
                        );
                        this.carregarDados(this.pagination.currentPage);
                    }
                })
                .catch((e) => {
                    console.error("Erro ao reativar colaborador.", e);
                    this.$root.showMessage(
                        "error",
                        "msg-failure-reativar-colaborador"
                    );
                })
                .finally((_) => {
                    this.removePrompt();
                    this.isLoading = false;
                });
        },
        removePrompt() {
            this.deleteThis = null;
            this.enableThis = null;
        },
        qtdMaxUsuarioVsQtdAtivos() {
            this.service.qtdUsuariosAtivos()
                .then(body => {
                    this.qtdUsuariosAtivos = body.content;
                })
                .finally(_ => {
                    this.limiteQdaAtivos = 
                        this.$store.state.user.clienteSovis.qtde_max_usuario_aparelho > 0 &&
                        this.qtdUsuariosAtivos >= this.$store.state.user.clienteSovis.qtde_max_usuario_aparelho;

                    this.$forceUpdate();
                });
        }
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;

        .tipos-servicos .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 80%;
                padding-right: 10px;
            }
            .situacao-select {
                width: 30%;
                div {
                    height: 40px;
                }
            }
            .filter-bar {
                width: 31%;
            }
            @media (max-width: 760px) {
                .search-bar {
                    padding-right: 0;
                }
                .situacao-select {
                    width: 100%;
                }
            }
        }
        .map-marker:hover {
            cursor: pointer;
            opacity: 0.5;
        }
    }
}
</style>
